import { CompositeDecorator } from 'draft-js';
import createLinkDecorator from './create-link-decorator';
import createLinkEntityDecorator from './create-link-entity-decorator';

const ignoredBlockTypes = ['code-block'];

export default function createTextEditorDecorator({ theme = {}, followLinks } = {}) {
  const linkTheme = theme.link;
  return new CompositeDecorator([
    createLinkDecorator({
      ignoredBlockTypes,
      theme: linkTheme,
      followLinks,
    }),
    createLinkEntityDecorator({ theme: linkTheme, followLinks }),
  ]);
}



// WEBPACK FOOTER //
// ./app/components/text-editor/decorators/create-text-editor-decorator.js